module.exports = __webpack_public_path__ + "media/images/icons/alert-55d27453357bdf624ed74e69c36c0ddd.svg";